export const BOOKING_TYPES = {
    BookingService: Symbol.for("BookingService"),
    TokenStorageKey: Symbol.for("TokenStorageKey"),
    ApiUri: Symbol.for("ApiUri"),
};
